<template>
  <el-dialog
    title="选择活动"
    :visible="true"
    width="1090px"
    center
    @close="dialogClose"
  >
    <!-- 导航切换 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="item.name"
        :name="`index${index}`"
        v-for="(item, index) in navList"
        :key="item.id"
      ></el-tab-pane>
    </el-tabs>
    <!-- 头部表单查询 -->
    <input-form
      ref="inputForm12"
      :btnPosition1="true"
      :defaultSelectArr="true"
      :inputData="inputData"
      @toParentVal="searchForm"
      :isDialog="true"
    ></input-form>
    <!-- 表格内容 -->
    <el-table
      :data="activityList"
      v-loading="talbeLoading"
      style="width: 100%; margin-top: 20px"
      ref="table"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
    >
      <template slot="empty">
        <div class="flex">
          <img src="@/assets/images/default/暂无任何数据.png" style="width: 250px;height: 250px;"/>
          <div style="">暂无任何数据</div>
        </div>
      </template>
      <el-table-column
        :label="activeName == 'index5' ? '礼品名称' : '活动名称'"
        prop="activityName"
      >
      </el-table-column>
      <el-table-column
        :label="activeName == 'index5' ? '礼品类型' : '活动类型'"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.activityType == 1"> 日历签到 </span>
          <span v-if="scope.row.activityType == 2"> 浏览礼品有礼 </span>
          <span v-if="scope.row.activityType == 3"> 每日抢好礼 </span>
          <span v-if="scope.row.activityType == 4"> 关注店铺有礼 </span>
          <span v-if="scope.row.activityType == 5"> 邀请开卡 </span>
          <span v-if="scope.row.activityType == 6"> 邀请关注店铺 </span>
          <span v-if="scope.row.activityType == 7"> 完善信息有礼 </span>
          <span v-if="scope.row.activityType == 8"> 大转盘抽奖 </span>
          <span v-if="scope.row.activityType == 9">兑换实物</span>
          <span v-if="scope.row.activityType == 10">兑换优惠券</span>
          <span v-if="scope.row.type == 11">新人优惠券</span>
          <span v-if="scope.row.type == 12">会员优惠券</span>
          <span v-if="scope.row.activityType == 13">开卡礼包</span>
          <span v-if="scope.row.activityType == 14">店铺礼包</span>
          <span v-if="scope.row.activityType == 15">店铺礼包（千人千面）</span>
          <span v-if="scope.row.activityType == 16">下单有礼</span>
          <span v-if="scope.row.activityType == 17">首购有礼</span>
          <span v-if="scope.row.activityType == 18">复购有礼</span>
          <span v-if="scope.row.activityType == 19">下单抽奖</span>
          <span v-if="scope.row.activityType == 20">评价有礼</span>
          <span v-if="scope.row.activityType == 21">裂变神券</span>
          <span v-if="scope.row.activityType == 22">天降红包雨</span>
          <span v-if="scope.row.activityType == 23">疯狂捉娃娃</span>
          <span v-if="scope.row.activityType == 24">大家来找茬</span>
          <span v-if="scope.row.activityType == 25">入会打榜</span>
          <span v-if="scope.row.activityType == 26">幸运抽签</span>
          <span v-if="scope.row.activityType == 27">0元试用</span>
          <span v-if="scope.row.activityType == 31">调查问卷</span>
          <span v-if="scope.row.activityType == 32">生日有礼</span>
          <span v-if="scope.row.activityType == 33">积分兑换</span>
          <span v-if="scope.row.activityType == 34">满额有礼</span>
          <span v-if="scope.row.activityType == 35">下单冲榜</span>
          <span v-if="scope.row.activityType == 37">会员升级礼</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="activeName == 'index5' ? '上下架时间' : '活动时间'"
      >
        <template slot-scope="scope">
          <div class="activityTime" v-if="activeName == 'index5'">
            <span>上架: {{ scope.row.startTime }}</span
            ><br />
            <span>下架: {{ scope.row.endTime }}</span>
          </div>
          <div v-else-if="activeName == 'index6'">
            起:<span>{{ scope.row.couponStartTime }}</span
            ><br />
            止:<span>{{ scope.row.couponEndTime }}</span>
          </div>
          <div class="activityTime" v-else>
            <span>起: {{ scope.row.startTime }}</span
            ><br />
            <span>止: {{ scope.row.endTime }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="活动状态">
        <template slot-scope="scope">
          <div v-if="activeName == 'index5'">
            <span v-if="scope.row.status == 1"> <i class="y1"></i>待上架 </span>
            <span v-if="scope.row.status == 2"> <i class="y2"></i>已上架 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已下架 </span>
          </div>
          <div v-else-if="activeName == 'index6'">
            <span v-if="scope.row.status == 2"> <i class="y1"></i>未开始 </span>
            <span v-if="scope.row.status == 1"> <i class="y2"></i>进行中 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已结束 </span>
          </div>
          <div v-else>
            <span v-if="scope.row.status == 1"> <i class="y1"></i>未开始 </span>
            <span v-if="scope.row.status == 2"> <i class="y2"></i>进行中 </span>
            <span v-if="scope.row.status == 3"> <i class="y3"></i>已结束 </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <div class="editList">
            <span
              v-if="
                scope.row.status != 3 ||
                  scope.row.activityType == 13 ||
                  scope.row.activityType == 14 ||
                  scope.row.activityType == 15
              "
              style="color:#2670FB"
              class="pointer"
              @click="handleSave(scope.row)"
            >
              选择
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="recordData.current"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="recordData.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="recordData.total"
      class="pagination"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "@/components/inputForm";
import { queryActivity } from "@/api/activityController";
import { exchangeActivityList } from "@/api/paradiseAndTaskCommonController.js";
import { queryPage } from "@/api/integralCenter/benefitActivityController";
export default {
  components: {
    inputForm,
  },
  data() {
    return {
      activeName: "index0",
      navList: [
        {
          name: "关注拉粉",
          id: 1,
        },
        {
          name: "无线营销",
          id: 2,
        },
        // {
        //   name: "裂变营销",
        //   id: 3,
        // },
        {
          name: "趣味抽奖",
          id: 4,
        },
        {
          name: "游戏中心",
          id: 5,
        },
        // {
        //   name: "会员商城",
        //   id: 6,
        // },
        // {
        //   name: "会员权益",
        //   id: 7,
        // },
      ],
      activityList: [],
      talbeLoading: false,
      recordData: {
        size: 10,
        current: 1,
        total: 0,
        status: 1,
      },
      // 头部表单配置项
      inputData: [
        {
          name: "活动名称:",
          val: "activityName",
          placeholder: "请输入活动名称",
          width: "150px",
        },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          width: "150px",
          selectArr: [
            // { label: "全部", id: null, defaultValue: 1 },
            { label: "未开始", id: 1, defaultValue: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
      ],
      mainType: 1,
    };
  },
  mounted() {
    this.getPolite();
  },
  methods: {
    // handleNav(item, index) {
    //   this.tabActive = index;
    //   this.navItem = item;
    //   this.getPolite();
    // },
    handleClick(tab) {
      this.recordData = {
        size: 10,
        current: 1,
        total: 0,
        status: 1,
      };
      console.log(tab);
      if (
        tab.index == 0 ||
        tab.index == 1 ||
        tab.index == 2 ||
        tab.index == 3 ||
        tab.index == 4
      ) {
        this.inputData.splice(
          0,
          2,
          {
            name: "活动名称:",
            val: "activityName",
            placeholder: "请输入活动名称",
            width: "150px",
          },
          {
            name: "活动状态:",
            val: "status",
            placeholder: "请选择",
            width: "150px",
            selectArr: [
              // { label: "全部", id: null, defaultValue: 1 },
              { label: "未开始", id: 1, defaultValue: 1 },
              { label: "进行中", id: 2 },
              { label: "已结束", id: 3 },
            ],
          }
        );
      }
      this.mainType = tab.index * 1 + 1;
      if (tab.index == 2) this.mainType = 4;
      if (tab.index == 3) this.mainType = 3;

      console.log(tab.index, 222);
      this.$refs.inputForm12.initVal();
      this.getPolite();
    },
    handleSave(val) {
      if (
        val.activityType == 13 ||
        val.activityType == 14 ||
        val.activityType == 15
      ) {
        return this.$message.warning("不能选择礼包类型活动");
      }
      this.$emit("handleClose", val);
    },
    dialogClose() {
      this.$emit("handleClose");
    },
    // 表单查询
    searchForm(form) {
      console.log(form, 123564);
      this.recordData.current = 1;
      this.recordData.activityName = form.activityName || "";
      this.recordData.status = form.status;
      this.recordData.username = form.username || "";
      this.getPolite();
    },
    async getPolite() {
      let params = {
        current: this.recordData.current,
        size: this.recordData.size,
        activityName: this.recordData.activityName,
        status: this.recordData.status,
        mainType: this.mainType,
        username: this.recordData.username,
      };

      let res = {};

      // 商城
      if (this.activeName == "index5") {
        res = await exchangeActivityList(params);
      } else if (this.activeName == "index6") {
        // 会员权益
        res = await queryPage(params);
      } else {
        //
        res = await queryActivity(params);
      }
      if(res.data&& res.data.records){
        this.activityList=res.data.records
      }else{
        this.activityList = []
      }
      this.recordData.total = res.data.total * 1;
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.getPolite();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.getPolite();
    },
  },
};
</script>

<style lang="scss" scoped>
.flex{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pagination {
  text-align: right;
  margin-top: 20px;
}
</style>
